import { render, staticRenderFns } from "./view-bin.vue?vue&type=template&id=00bd82ec&"
import script from "./view-bin.vue?vue&type=script&lang=ts&"
export * from "./view-bin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports